import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, GlobeIcon, InstagramIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { Seo } from '../components/Seo';
import { PageHero } from '../components/PageHero';
import { site } from '../data/site';
export function Contact() {
  return <>
      <Seo title="Contact — Goelst France S.A.R.L, rails à rideaux à Bignoles (Var)" description="Contactez Goelst France S.A.R.L : 869 Avenue des Chênes Verts, Bignoles 83170. Téléphone 0033 (0)4 946 974 28, e-mail info@g-rail-france.fr, ouvert du lundi au vendredi de 09:00 à 18:00." path="/contact" data-id="element-174" data-mp="1lrbfdwn256lp" />

      <PageHero breadcrumb="Contact" title="Contacter Goelst France S.A.R.L" lead="Pour une question technique, une demande de conseil sur un projet ou une consultation de gamme, le plus simple est de nous appeler ou de nous écrire. Précisez si possible le type de bâtiment, les hauteurs concernées et le mode de commande souhaité : la réponse sera d’autant plus précise." data-id="element-175" data-mp="17slfyacrmuu6" />

      <section className="border-b border-line bg-white" aria-labelledby="coordonnees-titre" data-id="element-176" data-mp="15dcct99nqa0c">
        <div className="mx-auto max-w-content px-6 py-14 md:py-16" data-id="element-177" data-mp="19exmklqwa86b">
          <h2 id="coordonnees-titre" className="text-2xl font-semibold tracking-tight text-ink md:text-3xl" data-id="element-178" data-mp="1e91up8bwcm8z">
            Coordonnées
          </h2>
          <div className="mt-10 grid gap-px bg-line md:grid-cols-2 lg:grid-cols-4" data-id="element-179" data-mp="mgkp8nn318qh">
            <div className="bg-white p-7" data-id="element-180" data-mp="minlhpetvy3n">
              <PhoneIcon className="h-5 w-5 text-signal" aria-hidden="true" data-id="element-181" data-mp="qhedji4fspjw" />
              <h3 className="mt-4 text-[15px] font-semibold uppercase tracking-[0.12em] text-ink-muted" data-id="element-182" data-mp="vhiutad65ob6">Téléphone</h3>
              <a href={site.phoneHref} className="mt-2 block text-[19px] font-medium text-ink transition-colors duration-150 ease-smooth hover:text-signal" data-id="element-183" data-mp="10gm08vx29wjo">
                {site.phoneDisplay}
              </a>
              <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-184" data-mp="2bxc0lyeszu5d">
                Le canal le plus rapide pendant les heures d’ouverture.
              </p>
            </div>
            <div className="bg-white p-7" data-id="element-185" data-mp="1h80sr46x2sil">
              <MailIcon className="h-5 w-5 text-signal" aria-hidden="true" data-id="element-186" data-mp="1w62vjc64j9ys" />
              <h3 className="mt-4 text-[15px] font-semibold uppercase tracking-[0.12em] text-ink-muted" data-id="element-187" data-mp="1w36uvg2w676n">E-mail</h3>
              <a href={site.emailHref} className="mt-2 block break-words text-[19px] font-medium text-ink transition-colors duration-150 ease-smooth hover:text-signal" data-id="element-188" data-mp="13gm5um9w2769">
                {site.email}
              </a>
              <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-189" data-mp="1d8046qq3t0xt">
                Idéal pour transmettre des plans ou un descriptif de projet.
              </p>
            </div>
            <div className="bg-white p-7" data-id="element-190" data-mp="kota4k3fq7uu">
              <MapPinIcon className="h-5 w-5 text-signal" aria-hidden="true" data-id="element-191" data-mp="frje2lljixy1" />
              <h3 className="mt-4 text-[15px] font-semibold uppercase tracking-[0.12em] text-ink-muted" data-id="element-192" data-mp="fpgqe87v1gwh">Adresse</h3>
              <address className="mt-2 not-italic text-[16px] leading-relaxed text-ink" data-id="element-193" data-mp="2w53bplxh1meb">
                {site.address.street}
                <br data-id="element-194" data-mp="2hhi9du8f7r7g" />
                {site.address.city}, {site.address.region}
                <br data-id="element-195" data-mp="2mf0k9q600gi3" />
                {site.address.postalCode}, {site.address.country}
              </address>
              <a href={site.mapLink} target="_blank" rel="noopener noreferrer" className="mt-3 inline-block text-[15px] text-ink-soft underline decoration-line underline-offset-4 hover:text-signal" data-id="element-196" data-mp="3a4uyab220b3x">
                Ouvrir l’itinéraire
              </a>
            </div>
            <div className="bg-white p-7" data-id="element-197" data-mp="3584g9i6ov5fv">
              <ClockIcon className="h-5 w-5 text-signal" aria-hidden="true" data-id="element-198" data-mp="1porje1hbyyqn" />
              <h3 className="mt-4 text-[15px] font-semibold uppercase tracking-[0.12em] text-ink-muted" data-id="element-199" data-mp="1tqwaasge9h9l">Horaires</h3>
              <dl className="mt-2 space-y-1.5 text-[16px] text-ink" data-id="element-200" data-mp="29yj35y6opccd">
                {site.hours.map(h => <div key={h.days} className="flex justify-between gap-4" data-id="element-201" data-mp="2569f6np4qmcq">
                    <dt className="text-ink-soft" data-id="element-202" data-mp="207y2843jfvqa">{h.days}</dt>
                    <dd data-id="element-203" data-mp="2064xiuchjlkx">{h.time}</dd>
                  </div>)}
              </dl>
            </div>
          </div>

          <div className="mt-10 flex flex-col gap-3 sm:flex-row" data-id="element-204" data-mp="2swmy9opqlav6">
            <a href={site.phoneHref} className="inline-flex items-center justify-center gap-2 bg-signal px-6 py-4 text-[15px] font-medium text-white transition-colors duration-150 ease-smooth hover:bg-signal-dark" data-id="element-205" data-mp="2susnh386iz4t">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-206" data-mp="2exvpmhtn8hef" />
              Appeler maintenant
            </a>
            <a href={site.emailHref} className="inline-flex items-center justify-center gap-2 border border-ink px-6 py-4 text-[15px] font-medium text-ink transition-colors duration-150 ease-smooth hover:bg-ink hover:text-white" data-id="element-207" data-mp="17kbrmbvw7qtx">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-208" data-mp="3j6dy1fvlrt2f" />
              Écrire un e-mail
            </a>
          </div>
        </div>
      </section>

      <section className="border-b border-line bg-bone" aria-labelledby="carte-titre" data-id="element-209" data-mp="3o3vvoa466lv4">
        <div className="mx-auto grid max-w-content gap-10 px-6 py-14 md:py-16 lg:grid-cols-[0.85fr_1.15fr]" data-id="element-210" data-mp="3sy04z00wr5zd">
          <div data-id="element-211" data-mp="1si940f7kmo2">
            <h2 id="carte-titre" className="text-2xl font-semibold leading-tight tracking-tight text-ink md:text-3xl" data-id="element-212" data-mp="6ph0wcbeghj3">
              Nous trouver
            </h2>
            <div className="mt-5 space-y-4 text-[17px] leading-relaxed text-ink-soft" data-id="element-213" data-mp="arlqmzyq8u0g">
              <p data-id="element-214" data-mp="fovrdbrkgs3l">
                Notre adresse se situe avenue des Chênes Verts, dans le secteur de Brignoles, au cœur du Var. L’accès se
                fait facilement en voiture depuis l’A8 et les axes reliant Aix-en-Provence, Toulon et le littoral.
              </p>
              <p data-id="element-215" data-mp="3krxr2cfo795b">
                Les visites se font sur rendez-vous, afin que la personne compétente sur votre type de projet soit
                disponible. Un appel ou un courriel préalable suffit à fixer un créneau.
              </p>
            </div>
            <ul className="mt-8 space-y-4 text-[16px]" data-id="element-216" data-mp="3tr1bpkuhjwlx">
              <li className="flex items-start gap-3" data-id="element-217" data-mp="3oszr2vhevp8c">
                <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-signal" aria-hidden="true" data-id="element-218" data-mp="3owdsa0ec9se7" />
                <a href={site.website} target="_blank" rel="noopener noreferrer" className="text-ink underline decoration-line underline-offset-4 hover:text-signal" data-id="element-219" data-mp="7jky53ye18l1">
                  goelst-international.com
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-220" data-mp="qbm40q9kxz3y">
                <InstagramIcon className="mt-0.5 h-4 w-4 shrink-0 text-signal" aria-hidden="true" data-id="element-221" data-mp="qaawqggxe983" />
                <a href={site.instagram} target="_blank" rel="noopener noreferrer" className="text-ink underline decoration-line underline-offset-4 hover:text-signal" data-id="element-222" data-mp="lb7wrafsyt6z">
                  Instagram — @goelst_international
                </a>
              </li>
            </ul>
          </div>
          <div className="overflow-hidden border border-line bg-white" data-id="element-223" data-mp="zygd0pnyxopt">
            <iframe title="Carte de localisation de Goelst France S.A.R.L à Brignoles" src={site.mapEmbed} className="h-[380px] w-full md:h-[460px]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-224" data-mp="m7l8tqoezvsk" />
          </div>
        </div>
      </section>

      <section className="bg-white" aria-labelledby="preparer-titre" data-id="element-225" data-mp="h9t9wcpcr9ev">
        <div className="mx-auto max-w-content px-6 py-16 md:py-20" data-id="element-226" data-mp="3b1v0o2o1jpo">
          <div className="max-w-3xl" data-id="element-227" data-mp="7bvixhg3yyik">
            <h2 id="preparer-titre" className="text-3xl font-semibold leading-tight tracking-tight text-ink md:text-4xl" data-id="element-228" data-mp="7au73ar9q7zs">
              Préparer votre demande
            </h2>
            <p className="mt-5 text-[17px] leading-relaxed text-ink-soft" data-id="element-229" data-mp="iri9io2uvoll">
              Ces quatre éléments nous permettent presque toujours de répondre dès le premier échange.
            </p>
          </div>
          <ul className="mt-12 grid gap-10 md:grid-cols-2 lg:grid-cols-4" data-id="element-230" data-mp="8ski9de1pgyw">
            {[{
            t: 'Le type de projet',
            d: 'Hôtel, établissement de santé, bureaux, commerce ou résidence : l’usage détermine le niveau d’équipement.'
          }, {
            t: 'Les dimensions',
            d: 'Largeur des baies, hauteur sous plafond, longueur de rail envisagée, et présence éventuelle d’angles ou de courbes.'
          }, {
            t: 'Le mode de commande',
            d: 'Manuel, électrique, motorisé avec télécommande ou piloté par la domotique du bâtiment.'
          }, {
            t: 'Le contexte de pose',
            d: 'Neuf ou rénovation, plafond ouvert ou fermé, alimentation électrique disponible ou non.'
          }].map(item => <li key={item.t} className="border-t border-line pt-6" data-id="element-231" data-mp="21rrd5ih9sc7b">
                <h3 className="text-lg font-semibold tracking-tight text-ink" data-id="element-232" data-mp="26q2nrvfe2qql">{item.t}</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-233" data-mp="1922c554k8c5p">{item.d}</p>
              </li>)}
          </ul>
          <p className="mt-12 max-w-3xl text-[17px] leading-relaxed text-ink-soft" data-id="element-234" data-mp="1e1nabdbwoghd">
            Vous pouvez également parcourir{' '}
            <Link to="/solutions" className="font-medium text-signal underline decoration-signal/40 underline-offset-4 hover:decoration-signal" data-id="element-235" data-mp="1ixvkecb8xjho">
              nos solutions de rails à rideaux
            </Link>{' '}
            avant de nous écrire, ou consulter{' '}
            <Link to="/ressources" className="font-medium text-signal underline decoration-signal/40 underline-offset-4 hover:decoration-signal" data-id="element-236" data-mp="v818py2ny0z0">
              la page ressources
            </Link>{' '}
            pour vérifier nos coordonnées sur les annuaires professionnels.
          </p>
        </div>
      </section>
    </>;
}